/**
 * Quick Shop sheet for collection product cards.
 * Mobile: bottom sheet. Desktop: slides in from the right.
 */
(function () {
  'use strict';

  var root = document.getElementById('quick-shop');
  if (!root) return;

  var titleEl = root.querySelector('.quick-shop__title');
  var badgeEl = root.querySelector('[data-quick-shop-badge]');
  var priceEl = root.querySelector('.quick-shop__price');
  var thumbEl = root.querySelector('.quick-shop__thumb');
  var ratingEl = root.querySelector('[data-quick-shop-rating]');
  var ratingTextEl = root.querySelector('[data-quick-shop-rating-text]');
  var starsFillEl = root.querySelector('[data-quick-shop-stars-fill]');
  var lengthWrap = root.querySelector('[data-quick-shop-length]');
  var chipsEl = root.querySelector('[data-quick-shop-chips]');
  var lengthNotifyEl = root.querySelector('[data-length-notify]');
  var qtyLabelEl = root.querySelector('[data-quick-shop-qty-label]');
  var qtyHintEl = root.querySelector('[data-quick-shop-qty-hint]');
  var packsEl = root.querySelector('[data-quick-shop-packs]');
  var stepperEl = root.querySelector('[data-quick-shop-stepper]');
  var qtyInput = root.querySelector('[data-quick-shop-qty-input]');
  var closureWrap = root.querySelector('[data-quick-shop-closure]');
  var closureToggle = root.querySelector('[data-quick-shop-closure-toggle]');
  var closureCheckLabel = root.querySelector('[data-quick-shop-closure-check-label]');
  var closureSelectWrap = root.querySelector('[data-quick-shop-closure-select-wrap]');
  var closureSelect = root.querySelector('[data-quick-shop-closure-select]');
  var stockEl = root.querySelector('[data-quick-shop-stock]');
  var atcBtn = root.querySelector('[data-quick-shop-atc]');
  var pdpLink = root.querySelector('[data-quick-shop-pdp]');
  var totalEl = root.querySelector('[data-quick-shop-total]');
  var lowStockEl = root.querySelector('[data-quick-shop-low-stock]');
  var guideRoot = root.querySelector('[data-quick-shop-guide]');
  var lastFocus = null;
  var hydrateSeq = 0;

  var state = {
    product: null,
    selectedLength: null,
    variantId: null,
    variantPrice: null,
    variantCompareAt: null,
    maxQty: null,
    packMode: '3',
    closureEnabled: false,
    closureVariantId: null,
    closurePrice: 0,
    notifyFocusLength: null
  };

  function getOptionName(product) {
    if (product && product.options && product.options[0]) return product.options[0];
    return 'Option';
  }

  function waitingAtcLabel(product) {
    return 'Choose a ' + getOptionName(product).toLowerCase();
  }

  function isComingSoon(product) {
    return !!(product && (product.coming_soon === true || product.launch_status === 'coming_soon'));
  }

  function isProductSoldOut(product) {
    if (!product || isComingSoon(product)) return false;
    if (product.available === false) return true;
    var variants = product.variants || [];
    return variants.length > 0 && !variants.some(function (v) { return v.available; });
  }

  function goToProduct(product) {
    var url =
      (product && product.url) ||
      (product && product.handle ? '/products/' + product.handle : null);
    if (url) window.location.href = url;
  }

  function syncOptionChrome(product) {
    if (!lengthWrap) return;
    var optionName = getOptionName(product);
    var labelEl = lengthWrap.querySelector('.quick-shop__label');
    if (labelEl) labelEl.textContent = '1. Choose ' + optionName;
    var guideBtn = lengthWrap.querySelector('[data-quick-shop-length-guide]');
    if (guideBtn) guideBtn.hidden = optionName.toLowerCase() !== 'length';
  }

  function clearOptionError() {
    if (lengthWrap) lengthWrap.classList.remove('is-error');
  }

  function showOptionError() {
    if (!lengthWrap || lengthWrap.hidden) return;
    lengthWrap.classList.remove('is-error');
    void lengthWrap.offsetWidth;
    lengthWrap.classList.add('is-error');
  }

  function setAtcWaiting(product) {
    atcBtn.removeAttribute('disabled');
    atcBtn.disabled = false;
    atcBtn.removeAttribute('data-qs-notify');
    atcBtn.setAttribute('aria-disabled', 'true');
    atcBtn.textContent = waitingAtcLabel(product);
  }

  function setAtcDisabled(label) {
    atcBtn.removeAttribute('aria-disabled');
    atcBtn.removeAttribute('data-qs-notify');
    atcBtn.disabled = true;
    if (label) atcBtn.textContent = label;
  }

  function setAtcNotify() {
    atcBtn.removeAttribute('aria-disabled');
    atcBtn.disabled = false;
    atcBtn.setAttribute('data-qs-notify', 'true');
    atcBtn.textContent = 'Notify Me When Available';
  }

  function setAtcReady(label) {
    atcBtn.removeAttribute('aria-disabled');
    atcBtn.removeAttribute('data-qs-notify');
    atcBtn.disabled = false;
    atcBtn.textContent = label || 'Add to cart';
  }

  function openNotifyFromQuickShop() {
    var product = state.product;
    if (!product || !window.SHHLaunchNotify) return;
    SHHLaunchNotify.open({
      handle: product.handle || '',
      title: product.title || '',
      url: product.url || (product.handle ? '/products/' + product.handle : window.location.href),
      mode: isComingSoon(product) ? 'coming_soon' : 'restock',
      product: product
    });
  }

  function stripMoneyHtml(value) {
    if (!value) return '';
    var tmp = document.createElement('div');
    tmp.innerHTML = String(value);
    return (tmp.textContent || tmp.innerText || '').trim();
  }

  function formatMoney(cents) {
    if (cents === null || cents === undefined || isNaN(cents)) return '—';
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return stripMoneyHtml(theme.Currency.formatMoney(cents, theme.moneyFormat));
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return stripMoneyHtml(Shopify.formatMoney(cents, (theme && theme.moneyFormat) || '${{amount}}'));
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function rememberCompareAt(variantId, compareAt) {
    if (!window.theme) window.theme = {};
    if (!theme.variantCompareAt) theme.variantCompareAt = {};
    if (variantId == null) return;
    if (compareAt != null && compareAt > 0) {
      theme.variantCompareAt[variantId] = compareAt;
      theme.variantCompareAt[String(variantId)] = compareAt;
    }
  }

  function registerProductCompareAt(product) {
    if (!product) return;
    (product.variants || []).forEach(function (v) {
      rememberCompareAt(v.id, v.compare_at_price);
    });
  }

  function setPriceDisplay(priceCents, compareAtCents, fromPrefix, revealSale) {
    if (!priceEl) return;
    if (priceCents === null || priceCents === undefined || isNaN(priceCents)) {
      priceEl.textContent = '';
      return;
    }

    if (revealSale && compareAtCents && compareAtCents > priceCents) {
      priceEl.innerHTML =
        (fromPrefix ? '<span class="product-price__from">From </span>' : '') +
        '<s class="product-price__price product-price__compare">' + formatMoney(compareAtCents) + '</s> ' +
        '<span class="product-price__price product-price__sale">' + formatMoney(priceCents) + '</span>';
    } else if (!revealSale && compareAtCents && compareAtCents > priceCents) {
      // Off BTS sale page: list compare-at as the normal price
      priceEl.textContent = (fromPrefix ? 'From ' : '') + formatMoney(compareAtCents);
    } else {
      priceEl.textContent = (fromPrefix ? 'From ' : '') + formatMoney(priceCents);
    }
  }

  function shouldRevealSale(product) {
    if (product && product.reveal_sale === true) return true;
    return !!(window.theme && theme.revealSalePrice === true);
  }

  function listedUnitPrice(priceCents, compareAtCents, revealSale) {
    if (!revealSale && compareAtCents && compareAtCents > priceCents) {
      return compareAtCents;
    }
    return priceCents;
  }

  function updateHeaderPrice() {
    var product = state.product;
    if (!product) {
      setPriceDisplay(null, null, false, false);
      return;
    }

    var revealSale = shouldRevealSale(product);

    if (state.selectedLength) {
      var variant = findVariant(product, state.selectedLength);
      if (variant) {
        setPriceDisplay(variant.price, variant.compare_at_price, false, revealSale);
        return;
      }
    }

    setPriceDisplay(product.price, product.compare_at_price, true, revealSale);
  }

  function parseCardData(button) {
    var card = button.closest('.product-card');
    if (!card) return null;
    var script = card.querySelector('.product-card__data');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  /**
   * Collection card JSON often truncates product.variants (observed 10 → 5),
   * same class of issue as PDP ProductJson. Fetch the full product.js payload
   * and merge variants while keeping card-only fields (bundle flag, ratings,
   * matching_closure, cropped title/image).
   */
  function mapAjaxVariant(v, existing) {
    existing = existing || {};
    return {
      id: v.id,
      title: v.title,
      option1: v.option1,
      option2: v.option2,
      option3: v.option3,
      available: v.available,
      price: v.price,
      compare_at_price: v.compare_at_price,
      // product.js omits inventory_quantity — keep Liquid values when present
      inventory_quantity:
        existing.inventory_quantity != null ? existing.inventory_quantity : v.inventory_quantity,
      inventory_management:
        existing.inventory_management != null
          ? existing.inventory_management
          : v.inventory_management != null
            ? v.inventory_management
            : null,
      inventory_policy:
        existing.inventory_policy != null
          ? existing.inventory_policy
          : v.inventory_policy != null
            ? v.inventory_policy
            : null
    };
  }

  function mergeAjaxVariants(product, full) {
    if (!product || !full || !full.variants || !full.variants.length) return product;
    var currentCount = (product.variants || []).length;
    if (full.variants.length < currentCount) return product;

    var byId = {};
    (product.variants || []).forEach(function (v) {
      if (v && v.id != null) byId[v.id] = v;
    });

    product.variants = full.variants.map(function (v) {
      return mapAjaxVariant(v, byId[v.id]);
    });

    if (full.price != null) product.price = full.price;
    if (full.compare_at_price != null) product.compare_at_price = full.compare_at_price;
    if (typeof full.available === 'boolean') product.available = full.available;

    return product;
  }

  function patchCardVariants(handle, variants) {
    if (!handle || !variants || !variants.length) return;
    document.querySelectorAll('.product-card__data').forEach(function (script) {
      try {
        var data = JSON.parse(script.textContent);
        if (data.handle !== handle) return;
        if ((data.variants || []).length >= variants.length) return;
        data.variants = variants;
        script.textContent = JSON.stringify(data);
      } catch (e) { /* ignore */ }
    });
  }

  function hydrateProductVariants(product) {
    if (!product || !product.handle) return Promise.resolve(product);

    return fetch('/products/' + encodeURIComponent(product.handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Quick Shop hydrate failed');
        return res.json();
      })
      .then(function (full) {
        var merged = mergeAjaxVariants(product, full);
        patchCardVariants(merged.handle, merged.variants);
        return merged;
      })
      .catch(function () {
        return product;
      });
  }

  function applyHydratedProduct(product, selectedLength) {
    var notifyLength = state.notifyFocusLength;
    state.product = product;
    registerProductCompareAt(product);
    renderLengthChips(product);

    if (selectedLength) {
      var stillExists = getLengthValues(product).indexOf(selectedLength) !== -1;
      if (stillExists) {
        state.selectedLength = selectedLength;
        Array.prototype.forEach.call(chipsEl.querySelectorAll('.quick-shop__chip'), function (chip) {
          chip.classList.toggle(
            'is-selected',
            chip.getAttribute('data-length') === selectedLength
          );
        });
      } else {
        state.selectedLength = null;
      }
    }

    syncPackUI();
    rebuildClosureOptions(true);
    updateHeaderPrice();
    updateAtc();

    if (notifyLength) {
      var notifyChip = null;
      Array.prototype.forEach.call(chipsEl.querySelectorAll('.quick-shop__chip'), function (chip) {
        if (chip.getAttribute('data-length') === notifyLength) notifyChip = chip;
      });
      if (notifyChip && notifyChip.classList.contains('is-unavailable')) {
        showChipNotify(notifyChip, notifyLength, findVariant(product, notifyLength));
      }
    }
  }

  function parseLengthInches(value) {
    if (!value) return null;
    var match = String(value).match(/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[1]) : null;
  }

  function getLengthValues(product) {
    var idx = product.length_option_index;
    if (idx === null || idx === undefined) return [];
    var values = [];
    var seen = {};
    (product.variants || []).forEach(function (v) {
      var key = 'option' + (idx + 1);
      var val = v[key];
      if (val && !seen[val]) {
        seen[val] = true;
        values.push(val);
      }
    });
    return values;
  }

  function hideUnderChipNotify() {
    if (!lengthNotifyEl) return;
    lengthNotifyEl.hidden = true;
    lengthNotifyEl.removeAttribute('data-launch-variant');
    lengthNotifyEl.removeAttribute('data-launch-length');
  }

  function stockLine() {
    return (stockEl && stockEl.querySelector('.stock-scarcity')) || stockEl;
  }

  function hideLengthNotify() {
    state.notifyFocusLength = null;
    if (chipsEl) {
      Array.prototype.forEach.call(chipsEl.querySelectorAll('.is-notify-focus'), function (chip) {
        chip.classList.remove('is-notify-focus');
      });
    }
    hideUnderChipNotify();
  }

  function unavailableIdsForLength(product, lengthValue) {
    var idx = product && product.length_option_index;
    var key = (idx === null || idx === undefined) ? null : 'option' + (idx + 1);
    var ids = [];
    (product && product.variants || []).forEach(function (v) {
      if (v.available) return;
      var matches = key
        ? v[key] === lengthValue
        : v.title === lengthValue || v.option1 === lengthValue;
      if (matches) ids.push(v.id);
    });
    return ids;
  }

  function applyStockNotify(lengthValue, variant) {
    var line = stockLine();
    if (!line) return;
    var product = state.product || {};
    var ids = unavailableIdsForLength(product, lengthValue);
    if (!ids.length && variant) ids.push(variant.id);
    stockEl.hidden = false;
    if (window.SHHStock && typeof SHHStock.applyNotifyFocus === 'function') {
      SHHStock.applyNotifyFocus(line, {
        length: lengthValue,
        variantIds: ids.join(','),
        handle: product.handle,
        title: product.title,
        url: product.url,
        mode: isComingSoon(product) ? 'coming_soon' : 'restock'
      });
      return;
    }
    var textEl = line.querySelector('[data-quick-shop-stock-text], [data-stock-scarcity-text]');
    var copy = lengthValue
      ? 'Notify me when ' + lengthValue + ' is back'
      : 'Notify me when this length is back';
    if (textEl) textEl.textContent = copy;
    else line.textContent = copy;
    line.setAttribute('data-launch-notify', '');
    if (ids.length) line.setAttribute('data-launch-variant', ids.join(','));
    if (lengthValue) line.setAttribute('data-launch-length', lengthValue);
  }

  function showChipNotify(btn, value, variant) {
    var lengthValue = (btn && btn.getAttribute('data-length')) || value || '';
    hideLengthNotify();
    if (btn) btn.classList.add('is-notify-focus');
    state.notifyFocusLength = lengthValue;
    hideUnderChipNotify();
    applyStockNotify(lengthValue, variant);
  }

  function findVariant(product, lengthValue) {
    var idx = product.length_option_index;
    if (idx === null || idx === undefined || !lengthValue) {
      return (product.variants || []).filter(function (v) { return v.available; })[0] ||
        (product.variants || [])[0] ||
        null;
    }
    var key = 'option' + (idx + 1);
    var match = (product.variants || []).filter(function (v) {
      return v[key] === lengthValue;
    });
    return match[0] || null;
  }

  function findClosestClosureVariant(closure, targetLength) {
    if (!closure || !closure.variants || !closure.variants.length) return null;

    var idx = closure.length_option_index;
    var available = closure.variants.filter(function (v) { return v.available; });
    var pool = available.length ? available : closure.variants;

    if (idx === null || idx === undefined) {
      return pool[0] || null;
    }

    var key = 'option' + (idx + 1);
    var targetInches = parseLengthInches(targetLength);

    var exact = pool.filter(function (v) { return v[key] === targetLength; })[0];
    if (exact) return exact;

    if (targetInches == null) return pool[0] || null;

    var best = null;
    var bestDiff = Infinity;
    pool.forEach(function (v) {
      var inches = parseLengthInches(v[key]);
      if (inches == null) return;
      var diff = Math.abs(inches - targetInches);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = v;
      }
    });
    return best || pool[0] || null;
  }

  function getQty() {
    var qty = parseInt(qtyInput.value, 10);
    if (isNaN(qty) || qty < 1) return 1;
    if (state.maxQty != null && qty > state.maxQty) {
      qtyInput.value = String(state.maxQty);
      return state.maxQty;
    }
    return qty;
  }

  function isBundleProduct(product) {
    return !!(product && product.is_bundle);
  }

  function updateRating(product) {
    if (!ratingEl || !ratingTextEl) return;
    var avg = product && product.rating_average != null ? Number(product.rating_average) : null;
    var count = product && product.rating_count != null ? Number(product.rating_count) : null;

    if (!avg || !count || isNaN(avg) || isNaN(count) || count < 1) {
      ratingEl.hidden = true;
      ratingTextEl.textContent = '';
      ratingEl.removeAttribute('aria-label');
      if (starsFillEl) starsFillEl.style.width = '0%';
      return;
    }

    var clamped = Math.max(0, Math.min(5, avg));
    var pct = Math.round((clamped / 5) * 1000) / 10;

    ratingEl.hidden = false;
    ratingEl.setAttribute('aria-label', clamped.toFixed(1) + ' out of 5 stars, ' + count + ' reviews');
    ratingTextEl.textContent = avg.toFixed(1) + ' (' + count.toLocaleString() + ' reviews)';
    if (starsFillEl) starsFillEl.style.width = pct + '%';
  }

  function updateStock(variant) {
    if (lowStockEl) {
      lowStockEl.hidden = true;
      lowStockEl.textContent = '';
    }
    if (!stockEl) return;
    var line = stockLine();
    var product = state.product || {};
    var comingSoon = isComingSoon(state.product);
    if (!variant && !comingSoon) {
      stockEl.hidden = true;
      return;
    }
    if (window.SHHStock) {
      var result = SHHStock.resolve(variant, {
        surface: 'quick_shop',
        comingSoon: comingSoon
      });
      SHHStock.apply(line, result, {
        notify: {
          handle: product.handle,
          title: product.title,
          url: product.url,
          mode: comingSoon ? 'coming_soon' : 'restock'
        }
      });
      if (result.tier === 'low' || result.tier === 'very_low') {
        state.maxQty = result.qty;
        qtyInput.max = String(result.qty);
        if (getQty() > result.qty) qtyInput.value = String(result.qty);
      } else {
        state.maxQty = null;
        qtyInput.removeAttribute('max');
      }
      return;
    }
    stockEl.hidden = !(variant && variant.available);
  }

  function updatePackPrices() {
    var unit = listedUnitPrice(state.variantPrice, state.variantCompareAt, shouldRevealSale(state.product));
    if (!packsEl || !unit) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-pack-price]'), function (el) {
        el.textContent = '';
      });
      return;
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-pack-price]'), function (el) {
      var qty = parseInt(el.getAttribute('data-pack-price'), 10);
      el.textContent = formatMoney(unit * qty);
    });
  }

  function updateTotal() {
    if (!totalEl) return;
    if (state.variantPrice === null || state.variantPrice === undefined) {
      totalEl.textContent = '—';
      return;
    }
    var unit = listedUnitPrice(state.variantPrice, state.variantCompareAt, shouldRevealSale(state.product));
    var total = unit * getQty();
    if (state.closureEnabled && state.closurePrice) {
      total += state.closurePrice;
    }
    totalEl.textContent = formatMoney(total);
  }

  function syncPackUI() {
    var bundle = isBundleProduct(state.product);
    if (!packsEl || !stepperEl) return;

    if (!bundle) {
      packsEl.hidden = true;
      stepperEl.hidden = false;
      if (qtyHintEl) qtyHintEl.hidden = true;
      if (qtyLabelEl) qtyLabelEl.textContent = '2. Choose quantity';
      return;
    }

    packsEl.hidden = false;
    if (qtyHintEl) qtyHintEl.hidden = false;
    if (qtyLabelEl) qtyLabelEl.textContent = '2. Choose bundle quantity';

    Array.prototype.forEach.call(packsEl.querySelectorAll('[data-quick-shop-pack]'), function (btn) {
      btn.classList.toggle('is-selected', btn.getAttribute('data-quick-shop-pack') === state.packMode);
    });

    stepperEl.hidden = state.packMode !== 'other';
  }

  function setPackMode(mode) {
    state.packMode = mode;
    if (mode === '2' || mode === '3') {
      qtyInput.value = mode;
    } else if (mode === 'other') {
      var current = parseInt(qtyInput.value, 10);
      if (current === 2 || current === 3 || isNaN(current) || current < 1) {
        qtyInput.value = '1';
      }
    }
    syncPackUI();
    updateAtc();
  }

  function getClosureLabel(variant, closure) {
    if (!variant) return closure.title || 'Closure';
    if (variant.title && variant.title !== 'Default Title') {
      return variant.title + ' — ' + formatMoney(variant.price);
    }
    return (closure.title || 'Closure') + ' — ' + formatMoney(variant.price);
  }

  function getClosurePool(closure) {
    if (!closure || !closure.variants) return [];
    var available = closure.variants.filter(function (v) { return v.available; });
    return available.length ? available : closure.variants;
  }

  function rebuildClosureOptions(preferMatch) {
    if (!closureWrap || !closureSelect) return;

    var closure = state.product && state.product.matching_closure;
    if (!closure || !closure.variants || !closure.variants.length) {
      closureWrap.hidden = true;
      state.closureEnabled = false;
      state.closureVariantId = null;
      state.closurePrice = 0;
      if (closureToggle) closureToggle.checked = false;
      if (closureSelectWrap) closureSelectWrap.hidden = true;
      return;
    }

    closureWrap.hidden = false;
    var pool = getClosurePool(closure);
    var matched = findClosestClosureVariant(closure, state.selectedLength);
    var selectedId = preferMatch && matched
      ? matched.id
      : (parseInt(closureSelect.value, 10) || (matched && matched.id) || (pool[0] && pool[0].id));

    var optionsHtml = '';
    pool.forEach(function (v) {
      optionsHtml +=
        '<option value="' + v.id + '"' +
        (selectedId === v.id ? ' selected' : '') +
        '>' + getClosureLabel(v, closure) + '</option>';
    });
    closureSelect.innerHTML = optionsHtml;
    syncClosureSelection();
  }

  function syncClosureSelection() {
    if (!closureWrap || !closureSelect) return;

    var closure = state.product && state.product.matching_closure;
    if (!closure) {
      state.closureVariantId = null;
      state.closurePrice = 0;
      return;
    }

    var pool = getClosurePool(closure);
    var matched = findClosestClosureVariant(closure, state.selectedLength);
    var selectedId = parseInt(closureSelect.value, 10);
    var selected = pool.filter(function (v) { return v.id === selectedId; })[0] || matched || pool[0];
    var labelVariant = selected || matched || pool[0];
    var basePrice = labelVariant ? labelVariant.price : closure.price || 0;

    if (closureCheckLabel) {
      closureCheckLabel.textContent = 'Add Closure + ' + formatMoney(basePrice);
    }

    if (state.closureEnabled) {
      if (closureSelectWrap) closureSelectWrap.hidden = false;
      state.closureVariantId = selected ? selected.id : null;
      state.closurePrice = selected ? selected.price : 0;
    } else {
      if (closureSelectWrap) closureSelectWrap.hidden = true;
      state.closureVariantId = null;
      state.closurePrice = 0;
    }
  }

  function updateAtc() {
    var product = state.product;
    if (!product) {
      setAtcDisabled();
      state.variantPrice = null;
      state.variantCompareAt = null;
      updatePackPrices();
      updateHeaderPrice();
      updateTotal();
      return;
    }

    var lengths = getLengthValues(product);
    var needsLength = lengths.length > 0;

    if (isComingSoon(product)) {
      var soonVariant = state.selectedLength ? findVariant(product, state.selectedLength) : (product.variants || [])[0];
      state.variantId = soonVariant ? soonVariant.id : null;
      state.variantPrice = soonVariant ? soonVariant.price : null;
      state.variantCompareAt = soonVariant ? soonVariant.compare_at_price : null;
      setAtcReady('View product');
      updateStock(soonVariant);
      updatePackPrices();
      syncClosureSelection();
      updateHeaderPrice();
      updateTotal();
      return;
    }

    if (isProductSoldOut(product)) {
      var soldVariant = state.selectedLength ? findVariant(product, state.selectedLength) : (product.variants || [])[0];
      state.variantId = soldVariant ? soldVariant.id : null;
      state.variantPrice = soldVariant ? soldVariant.price : null;
      state.variantCompareAt = soldVariant ? soldVariant.compare_at_price : null;
      setAtcNotify();
      updateStock(soldVariant);
      updatePackPrices();
      syncClosureSelection();
      updateHeaderPrice();
      updateTotal();
      return;
    }

    if (needsLength && !state.selectedLength) {
      state.variantId = null;
      state.variantPrice = null;
      state.variantCompareAt = null;
      state.maxQty = null;
      setAtcWaiting(product);
      updateStock(null);
      updatePackPrices();
      syncClosureSelection();
      updateHeaderPrice();
      updateTotal();
      return;
    }

    var variant = findVariant(product, state.selectedLength);
    state.variantId = variant ? variant.id : null;
    state.variantPrice = variant ? variant.price : null;
    state.variantCompareAt = variant ? variant.compare_at_price : null;

    if (!variant || !variant.available) {
      setAtcNotify();
      updateStock(variant);
      updatePackPrices();
      syncClosureSelection();
      updateHeaderPrice();
      updateTotal();
      return;
    }

    setAtcReady('Add to cart');
    updateStock(variant);
    updatePackPrices();
    syncClosureSelection();
    updateHeaderPrice();
    updateTotal();
  }

  function renderLengthChips(product) {
    hideLengthNotify();
    var lengths = getLengthValues(product);
    chipsEl.innerHTML = '';
    chipsEl.classList.toggle('quick-shop__chips--few', lengths.length > 0 && lengths.length <= 4);

    if (!lengths.length) {
      lengthWrap.hidden = true;
      state.selectedLength = null;
      return;
    }

    lengthWrap.hidden = false;
    lengths.forEach(function (value) {
      var variant = findVariant(product, value);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'quick-shop__chip';
      btn.textContent = value;
      btn.setAttribute('data-length', value);
      if (!variant || (!variant.available && !isComingSoon(product))) {
        btn.classList.add('is-unavailable');
      }
      btn.addEventListener('click', function () {
        clearOptionError();
        var oos = btn.classList.contains('is-unavailable') && !isComingSoon(product);
        if (oos) {
          showChipNotify(btn, btn.getAttribute('data-length') || value, variant);
          return;
        }
        hideLengthNotify();
        state.selectedLength = value;
        Array.prototype.forEach.call(chipsEl.querySelectorAll('.quick-shop__chip'), function (chip) {
          chip.classList.toggle('is-selected', chip.getAttribute('data-length') === value);
        });
        rebuildClosureOptions(true);
        updateAtc();
      });
      chipsEl.appendChild(btn);
    });
  }

  function openGuide() {
    if (!guideRoot) return;
    guideRoot.hidden = false;
    guideRoot.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      guideRoot.classList.add('is-open');
    });
  }

  function closeGuide() {
    if (!guideRoot) return;
    guideRoot.classList.remove('is-open');
    guideRoot.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      guideRoot.hidden = true;
    }, 220);
  }

  function open(product) {
    var openToken = ++hydrateSeq;

    state.product = product;
    state.selectedLength = null;
    hideLengthNotify();
    state.variantId = null;
    state.variantPrice = null;
    state.variantCompareAt = null;
    state.maxQty = null;
    state.packMode = isBundleProduct(product) ? '3' : 'other';
    state.closureEnabled = false;
    state.closureVariantId = null;
    state.closurePrice = 0;
    state.notifyFocusLength = null;

    registerProductCompareAt(product);

    if (lowStockEl) {
      lowStockEl.hidden = true;
      lowStockEl.textContent = '';
    }
    if (stockEl) stockEl.hidden = true;
    if (closureToggle) closureToggle.checked = false;
    if (closureSelectWrap) closureSelectWrap.hidden = true;

    qtyInput.value = isBundleProduct(product) ? '3' : '1';
    qtyInput.removeAttribute('max');

    titleEl.textContent = product.title || '';
    if (badgeEl) {
      var badge = product.badge;
      if (badge && badge.label) {
        badgeEl.hidden = false;
        badgeEl.textContent = badge.label;
        badgeEl.className = 'badge quick-shop__badge' + (badge.class ? ' ' + badge.class : '');
      } else {
        badgeEl.hidden = true;
        badgeEl.textContent = '';
        badgeEl.className = 'badge quick-shop__badge';
      }
    }
    syncOptionChrome(product);
    clearOptionError();
    updateHeaderPrice();
    updateRating(product);

    if (pdpLink) {
      pdpLink.href = product.url || (product.handle ? '/products/' + product.handle : '/collections/all');
    }

    if (product.featured_image) {
      thumbEl.src = product.featured_image;
      thumbEl.alt = product.title || '';
      thumbEl.hidden = false;
    } else {
      thumbEl.removeAttribute('src');
      thumbEl.hidden = true;
    }

    renderLengthChips(product);
    syncPackUI();
    rebuildClosureOptions(true);
    updateAtc();

    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('quick-shop-open');

    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });

    // Restore full variant list when collection card JSON was truncated
    var cardVariantCount = (product.variants || []).length;
    hydrateProductVariants(product).then(function (hydrated) {
      if (openToken !== hydrateSeq) return;
      if (!state.product || state.product.handle !== hydrated.handle) return;
      if ((hydrated.variants || []).length <= cardVariantCount) return;
      applyHydratedProduct(hydrated, state.selectedLength);
    });
  }

  function close() {
    closeGuide();
    hydrateSeq += 1;
    root.classList.remove('is-open');
    document.body.classList.remove('quick-shop-open');
    root.setAttribute('aria-hidden', 'true');

    window.setTimeout(function () {
      root.hidden = true;
      clearOptionError();
      state.product = null;
      state.selectedLength = null;
      state.variantId = null;
      state.variantPrice = null;
      state.maxQty = null;
      state.closureEnabled = false;
      state.closureVariantId = null;
      state.closurePrice = 0;
      state.notifyFocusLength = null;
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }, 280);
  }

  function showSuccess(data, qty) {
    if (window.theme && theme.CartDrawer && theme.CartDrawer.isEnabled) {
      theme.CartDrawer.showAdded(data, qty);
      return;
    }
    var successDrawer = document.getElementById('successDrawer');
    if (successDrawer) {
      var pimg = data.image || '';
      var pimgPath = pimg.replace(/(\.[^\.]*$|$)/, '_small' + '$&');
      var imgEl = successDrawer.querySelector('.modal-prod-img');
      var nameEl = successDrawer.querySelector('.modal-prod-name');
      if (imgEl) imgEl.setAttribute('src', pimgPath);
      if (nameEl) nameEl.textContent = data.product_title;
      document.body.classList.add('loading', 'showOverly');
      $(successDrawer).fadeIn(500);
      window.setTimeout(function () {
        document.body.classList.remove('loading', 'showOverly');
        $(successDrawer).fadeOut(200);
      }, 8000);
    }
  }

  function showError(errormsg) {
    setAtcReady('Add to cart');
    if (window.theme && theme.CartDrawer && theme.CartDrawer.isEnabled && theme.CartDrawer.showError) {
      theme.CartDrawer.showError(errormsg);
      return;
    }
    var errorDrawer = document.getElementById('errorDrawer');
    if (errorDrawer) {
      var msgEl = errorDrawer.querySelector('.error-message');
      if (msgEl) msgEl.textContent = errormsg;
      document.body.classList.add('loading', 'showOverly');
      $(errorDrawer).fadeIn(500);
    } else {
      window.alert(errormsg);
    }
  }

  function addClosureThenFinish(mainData, qty) {
    if (!state.closureEnabled || !state.closureVariantId) {
      document.body.classList.remove('loading');
      close();
      showSuccess(mainData, qty);
      return;
    }

    function closureSuccess() {
      document.body.classList.remove('loading');
      close();
      showSuccess(mainData, qty);
    }

    function closureError(parsed, extra) {
      document.body.classList.remove('loading');
      close();
      showSuccess(mainData, qty);
      window.setTimeout(function () {
        if (theme.CartAdd && theme.CartAdd.presentError) {
          theme.CartAdd.presentError(parsed, {
            retry: extra && extra.retry,
            inApp: extra && extra.inApp,
            displayMessage: (parsed && parsed.message) ||
              'Bundle added, but the closure could not be added. Please try again.'
          });
          return;
        }
        showError('Bundle added, but the closure could not be added.');
      }, 400);
    }

    if (theme.CartAdd && theme.CartAdd.addItem) {
      theme.CartAdd.addItem(state.closureVariantId, 1, {}, {
        surface: 'quick_shop_closure',
        success: closureSuccess,
        error: closureError
      });
      return;
    }

    CartJS.addItem(state.closureVariantId, 1, {}, {
      success: closureSuccess,
      error: function (jqXHR) {
        var parsed = { message: '', retryable: true, status: 0 };
        try {
          parsed.message = JSON.parse(jqXHR.responseText).description || '';
        } catch (e) {}
        closureError(parsed, {});
      }
    });
  }

  function addToCart() {
    var product = state.product;
    if (!product) return;
    if (isComingSoon(product)) {
      goToProduct(product);
      return;
    }

    if (getLengthValues(product).length > 0 && !state.selectedLength) {
      showOptionError();
      return;
    }

    if (atcBtn.disabled || !state.variantId) return;

    var qty = getQty();
    if (state.maxQty != null && qty > state.maxQty) {
      qty = state.maxQty;
      qtyInput.value = String(qty);
    }

    if (typeof CartJS === 'undefined' || !theme.ajax_cart) {
      var url = '/cart/add?id=' + state.variantId + '&quantity=' + qty;
      if (state.closureEnabled && state.closureVariantId) {
        url = '/cart/add?id=' + state.variantId + '&quantity=' + qty;
      }
      window.location.href = url;
      return;
    }

    atcBtn.setAttribute('disabled', 'disabled');
    atcBtn.disabled = true;
    atcBtn.removeAttribute('aria-disabled');
    atcBtn.textContent = 'Adding…';
    document.body.classList.add('loading');

    function hairSuccess(data) {
      addClosureThenFinish(data, qty);
    }

    function hairError(parsed, extra) {
      document.body.classList.remove('loading');
      if (theme.CartAdd && theme.CartAdd.presentError) {
        setAtcReady('Add to cart');
        theme.CartAdd.presentError(parsed, extra);
        return;
      }
      var errormsg = (parsed && parsed.message) || 'Unable to add to cart';
      showError(errormsg);
    }

    if (theme.CartAdd && theme.CartAdd.addItem) {
      theme.CartAdd.addItem(state.variantId, qty, {}, {
        surface: 'quick_shop',
        success: hairSuccess,
        error: hairError
      });
      return;
    }

    CartJS.addItem(state.variantId, qty, {}, {
      success: hairSuccess,
      error: function (jqXHR) {
        var parsed = { message: '', retryable: true, status: 0 };
        try {
          parsed.message = JSON.parse(jqXHR.responseText).description || '';
        } catch (e) {}
        hairError(parsed, {});
      }
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-shop]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var product = parseCardData(trigger);
      if (product) open(product);
      return;
    }

    if (e.target.closest('[data-quick-shop-guide-close]')) {
      e.preventDefault();
      closeGuide();
      return;
    }

    if (e.target.closest('[data-quick-shop-length-guide]')) {
      e.preventDefault();
      openGuide();
      return;
    }

    if (e.target.closest('[data-quick-shop-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var packBtn = e.target.closest('[data-quick-shop-pack]');
    if (packBtn && root.contains(packBtn)) {
      e.preventDefault();
      setPackMode(packBtn.getAttribute('data-quick-shop-pack'));
      return;
    }

    var qtyBtn = e.target.closest('[data-quick-shop-qty]');
    if (qtyBtn && root.contains(qtyBtn)) {
      e.preventDefault();
      var current = getQty();
      if (qtyBtn.getAttribute('data-quick-shop-qty') === 'plus') {
        var next = current + 1;
        if (state.maxQty != null && next > state.maxQty) next = state.maxQty;
        qtyInput.value = String(next);
      } else if (current > 1) {
        qtyInput.value = String(current - 1);
      }
      updateTotal();
      return;
    }

    if (e.target.closest('[data-quick-shop-atc]')) {
      e.preventDefault();
      if (isComingSoon(state.product)) {
        goToProduct(state.product);
        return;
      }
      if (atcBtn.getAttribute('data-qs-notify') === 'true') {
        openNotifyFromQuickShop();
        return;
      }
      addToCart();
    }
  });

  if (closureToggle) {
    closureToggle.addEventListener('change', function () {
      state.closureEnabled = !!closureToggle.checked;
      syncClosureSelection();
      updateTotal();
    });
  }

  if (closureSelect) {
    closureSelect.addEventListener('change', function () {
      syncClosureSelection();
      updateTotal();
    });
  }

  qtyInput.addEventListener('input', function () {
    if (isBundleProduct(state.product) && state.packMode !== 'other') {
      state.packMode = 'other';
      syncPackUI();
    }
    updateTotal();
  });

  if (pdpLink) {
    pdpLink.addEventListener('click', function (e) {
      var url = (state.product && state.product.url) ||
        (state.product && state.product.handle ? '/products/' + state.product.handle : null) ||
        pdpLink.getAttribute('href');
      if (!url || url === '#') {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      window.location.assign(url);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (guideRoot && guideRoot.classList.contains('is-open')) {
      closeGuide();
      return;
    }
    if (root.classList.contains('is-open')) {
      close();
    }
  });

  window.SHHQuickShop = {
    getProduct: function () { return state.product; }
  };
})();
